import './LoadingAnimation.css';

export default function LoadingAnimation() {
  return (
    <div className="flex gap-1">
      <div className="animate-pulse-dot h-1 w-1 rounded-full bg-slate-500"></div>
      <div className="animate-pulse-dot-delay-1 h-1 w-1 rounded-full bg-slate-500"></div>
      <div className="animate-pulse-dot-delay-2 h-1 w-1 rounded-full bg-slate-500"></div>
    </div>
  );
}
